(() => {
  if (window.__imsGrowthTracking) return;
  window.__imsGrowthTracking = true;

  const publish = (name, detail = {}) => {
    const payload = { ...detail, page_path: location.pathname, page_url: location.href, event_time: new Date().toISOString() };
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish(name, payload);
      }
    } catch (_) {}
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: name, ...payload });
    } catch (_) {}
    try { window.dispatchEvent(new CustomEvent('imscrews:' + name, { detail: payload })); } catch (_) {}
  };

  const selectedSpecs = root => [...root.querySelectorAll('[data-finder-part]')]
    .filter(field => field.value)
    .reduce((data, field) => {
      data[field.dataset.finderPart] = field.value;
      return data;
    }, {});

  document.addEventListener('change', event => {
    const field = event.target.closest('[data-finder-part]');
    if (!field) return;
    const root = field.closest('[data-fastener-finder]');
    if (root && !root.dataset.trackingStarted) {
      root.dataset.trackingStarted = 'true';
      publish('finder_started', { source: 'homepage' });
    }
    publish('finder_filter_selected', {
      filter_name: field.dataset.finderPart,
      filter_value: field.value,
      selected_specs: root ? selectedSpecs(root) : {}
    });
  });

  document.addEventListener('submit', event => {
    const form = event.target.closest('[data-finder-form]');
    if (!form) return;
    const root = form.closest('[data-fastener-finder]');
    publish('finder_search_submitted', {
      search_query: form.querySelector('[data-finder-query]')?.value || '',
      selected_specs: root ? selectedSpecs(root) : {}
    });
  });

  document.addEventListener('click', event => {
    const relaxed = event.target.closest('[data-relaxed-filter]');
    if (relaxed) {
      publish('finder_filter_relaxed', {
        removed_filter: relaxed.dataset.relaxedFilter || '',
        original_query: relaxed.dataset.originalQuery || ''
      });
      return;
    }
    const request = event.target.closest('[data-zero-request]');
    if (request) {
      publish('finder_size_requested', { requested_specification: request.dataset.requestedSpec || '' });
      return;
    }
    const productLink = event.target.closest('.template-search__results a[href*="/products/"]');
    if (productLink) {
      publish('finder_product_clicked', {
        product_url: productLink.href,
        search_query: document.querySelector('[data-search-query]')?.dataset.searchQuery || ''
      });
      return;
    }
    const amazonLink = event.target.closest('a[href*="amazon.com"],a[href*="amzn.to"],a[href*="amazon.ca"],a[href*="amazon.co.jp"]');
    if (amazonLink) publish('amazon_outbound_clicked', { destination_url: amazonLink.href, link_text: amazonLink.textContent.trim().slice(0, 120) });
  });

  document.addEventListener('DOMContentLoaded', () => {
    const searchRoot = document.querySelector('[data-search-query]');
    if (!searchRoot) return;
    const count = Number(searchRoot.dataset.searchCount || 0);
    const query = searchRoot.dataset.searchQuery || '';
    publish(count > 0 ? 'finder_results_viewed' : 'finder_zero_results', {
      search_query: query,
      results_count: count
    });
  });
})();